import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=a3234224&scoped=true"
import script from "./Google.vue?vue&type=script&lang=js"
export * from "./Google.vue?vue&type=script&lang=js"
import style0 from "./Google.scss?vue&type=style&index=0&id=a3234224&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3234224",
  null
  
)

export default component.exports